import { z } from 'zod';
import { SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';
import { CandidateReputationActions } from '@axiom/const';

export const CandidateReputationHistoryItemSchema = z.object({
  actionTaken: z.enum(
    ZodArrayToEnum(Object.values(CandidateReputationActions))
  ),
  actionTakenAt: SchemaTimestamp,
  actionTakenBy: z.string().uuid(),
  actionNotes: z.string().nullable(),
});

export type CandidateReputationHistoryItem = z.infer<
  typeof CandidateReputationHistoryItemSchema
>;

export const CandidateReputationHistorySchema = z.object({
  actionTakenHistory: z.array(CandidateReputationHistoryItemSchema),
});

export type CandidateReputationHistory = z.infer<
  typeof CandidateReputationHistorySchema
>;
